module.exports = __webpack_public_path__ + "static/media/go.b9c6dd84.svg";